import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { Alert, Button, Text } from '@/ui'
import { useReselector } from '@/utils/sharedHooks'
import { TypographyStyles } from '@/styles'
import { useAnalyticsTrack } from '@/features/amplitude'
import { selectPracticeOverviewAlertType } from './practiceOverviewAlerts.selectors'

const PracticeOverviewAlert: FC = () => {
  const navigate = useNavigate()
  const track = useAnalyticsTrack()
  const alertType = useReselector(selectPracticeOverviewAlertType)

  if (!alertType) {
    return null
  }

  const buttonClassName = 'mt-4'

  switch (alertType) {
    case 'BANK_STATEMENTS':
      return (
        <Alert variant="warning" title="Data pending">
          <div style={{ display: 'flex', gap: 16 }}>
            <Text variant={TypographyStyles.BODY_MD}>
              We need your <strong>bank statements</strong> to provide an
              accurate view of your Practice Overview insights. Upload your
              statements so we can complete your catch-up bookkeeping.
            </Text>
            <Button
              onClick={() => {
                track(
                  'Clicked Upload Statements Button in Practice Overview Alert'
                )
                navigate('/practice/documents?tab=bank')
              }}
              size="sm"
              className={`${buttonClassName} w-auto whitespace-nowrap`}
            >
              Upload Statements →
            </Button>
          </div>
        </Alert>
      )

    case 'CLARIFY_TRANSACTIONS':
      return (
        <Alert variant="warning" title="Data pending">
          <div style={{ display: 'flex', gap: 16 }}>
            <Text variant={TypographyStyles.BODY_MD}>
              Please clarify <strong>outstanding transactions</strong> so we can
              complete your catch-up bookkeeping. This is needed to provide an
              accurate view of your Practice Overview insights.
            </Text>
            <Button
              onClick={() => {
                track(
                  'Clicked Clarify Transactions Button in Practice Overview Alert'
                )
                navigate('/transactions/review')
              }}
              size="sm"
              className={buttonClassName}
            >
              Clarify Transactions →
            </Button>
          </div>
        </Alert>
      )

    case 'CUBK_IN_PROGRESS':
      return (
        <Alert variant="warning" title="Catch-up bookkeeping in progress">
          <Text variant={TypographyStyles.BODY_MD}>
            This is a <strong>preview</strong> of your Practice Overview
            insights. Your data will be finalized after we complete your
            catch-up bookkeeping.
          </Text>
        </Alert>
      )

    default:
      return null
  }
}

export default PracticeOverviewAlert
